import { render, staticRenderFns } from "./IndexRegistered.vue?vue&type=template&id=70467728&scoped=true&"
import script from "./IndexRegistered.vue?vue&type=script&lang=js&"
export * from "./IndexRegistered.vue?vue&type=script&lang=js&"
import style0 from "./IndexRegistered.vue?vue&type=style&index=0&id=70467728&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70467728",
  null
  
)

export default component.exports